/**
 * @format
 * @flow
 */
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as Actions from '../../../actions/Setting';
import Template from '../../../components/Template/AfterLoginTemplate';
import * as RT from '../../../constants/Routing';
import Modal from "../../../components/Common/Modal";
import { Link } from "react-router-dom";
import PlaceHolderImg2x from "../../../assets/images/placeholder@2x.png";
var EMPTY_DELTA = { ops: [] };

class Component extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedId: '-1'
        }
        this.currentUser = JSON.parse(localStorage.getItem('current_user'));
    }

    componentWillMount = () => {
        const token = this.currentUser.accessToken;
        const { enterpriseId } = this.currentUser;
        this.props.getSetting(enterpriseId, token, this.currentUser.email);
    };

    renderFaqItems = (questions) => {
        const { selectedId } = this.state;
        return questions.map((item, index) => {
            return (
                <div className="question-answer-block">
                    <ul>
                        <li className={selectedId == item.faqId ? "Faq_list1" : "Faq_list"} onClick={() => {
                            this.state.selectedId == item.faqId ?
                                this.setState({ selectedId: '' }) :
                                this.setState({ selectedId: '' }, () => {
                                    this.setState({ selectedId: item.faqId })
                                })
                        }}>
                            <span>{item.question}</span>
                            <i className={selectedId == item.faqId ? "fas fa-sort-up Faq_down_img" : "fas fa-sort-down Faq_down_img"} />
                        </li>
                        {selectedId == item.faqId &&
                            <div className="Faq_list_body">
                                <div dangerouslySetInnerHTML={{ __html: item.answer }} />
                                <div className="Faq_close_btn" onClick={() => {
                                    this.setState({ selectedId: '' })
                                }}>閉じる</div>
                            </div>}
                    </ul>
                </div>
            )
        })
    }

    renderFaqData = () => {
        if (this.props.Setting.currentSetting != undefined && this.props.Setting.currentSetting.faq) {
            const Faq = this.props.Setting.currentSetting.faq;
            return Object.keys(Faq)
                .map((key) => {
                    var object = Faq[key]
                    return (
                        <div className="Faq_block">
                            <div className="Faq_title"> {key} </div>
                            {this.renderFaqItems(object)}
                        </div>
                    )
                });

        }

    }

    render = () => {
        return (
            <Template>
                <Modal
                    isOpen={this.props.App.modalOpen}
                    closeModal={this.props.modalCloseInAuth}
                    headerTitle={this.props.App.modalHeader}
                    okClickHandler={() => this.props.modalCloseInTask()}
                    okText="閉じる"
                    okBtnClass="btn btn-primary"
                >
                    {this.props.App.modalText}
                </Modal>
                <div className="">
                    <h2>よくあるご質問</h2>
                    <div>タスケルをご利用する際のよくあるご質問にお答えいたします。こちらのページで疑問が解決できない場合には
                        <span><Link to={RT.CONTACT_PATH}> タスケルサポートセンター </Link>までお問い合わせください。</span>
                    </div>
                </div>
                {this.renderFaqData()}
            </Template>
        );
    };
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => bindActionCreators(Actions, dispatch);

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default withRouter(Container);
